import { useSelector, useDispatch } from 'react-redux';

import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Text,
} from '@frontend/legacy-components';

import { isSuperUserOrGroupAdmin as getIsSuperUserOrGroupAdmin } from 'store/session/selectors';

import CreateManagedIntegrationTemplateForm from './Form';
import { managedIntegrationDrawer } from './data/actions';
import {
  isManagedIntegrationsCreateEditDrawerOpen,
  isEditingManagedIntegration,
  getIsSuperUser,
} from './data/reducer';

const CreateManagedIntegrationDrawer = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isManagedIntegrationsCreateEditDrawerOpen);
  const isSuperUserOrGroupAdmin = useSelector(getIsSuperUserOrGroupAdmin);
  const isSuperUserOverride = useSelector(getIsSuperUser);
  const isSuperUser = isSuperUserOverride ?? isSuperUserOrGroupAdmin;
  const isEditing = useSelector(isEditingManagedIntegration);
  const handleClose = () => dispatch(managedIntegrationDrawer.close());
  return (
    <Drawer isOpen={isOpen} onClose={handleClose}>
      <DrawerContent>
        <DrawerHeader>
          <Text
            color={isSuperUser ? 'interaction.superuser' : 'feature.primary'}
            fontWeight="inherit"
            fontSize="inherit"
            lineHeight="inherit"
          >
            {isEditing
              ? isSuperUser
                ? 'Superuser Edit Integration Settings'
                : 'Edit Integration Settings'
              : isSuperUser
              ? 'Superuser Create Integration'
              : 'Create Integration'}
          </Text>
          <DrawerCloseButton />
        </DrawerHeader>
        <CreateManagedIntegrationTemplateForm />
      </DrawerContent>
    </Drawer>
  );
};

export default CreateManagedIntegrationDrawer;
